module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen1-7f230a1850779274061fb4f7c7359100.png";